import 'babel-polyfill';
import m from 'mithril';
import 'simplebar';
import 'simplebar/dist/simplebar.css';

import pino from 'pino';
import defaultPage from './pages/home';
import reports from './pages/reports';
import dashboard from './pages/dashboard';
import stationFinder from './pages/station-finder';
import journeyPlan from './pages/journey-plan';
import journeyPlanAdd from './pages/journey-plan-add';
import cardList from './pages/cards';
import departments from './pages/departments';
import drivers from './pages/drivers';
import transactions from './pages/transactions';
import topUps from './pages/topups';
import cardToCard from './pages/card-to-card';
import cardToCardSingle from './pages/card-to-card-single';
import cardToCardBulk from './pages/card-to-card-bulk';
import profiles from './pages/profiles';
import triggers from './pages/triggers';
import alerts from './pages/alerts';
import notifications from './pages/notifications';
import support from './pages/support';
import tutorials from './pages/tutorials';
import config from './config';
import trends from './pages/trends';
import auth from './pages/auth';
import usermanagement from './pages/usermanagement';

const logger = pino();

window.logger = logger;

logger.info('app innitialized', { env: window.env });

m.route.prefix('');
m.route(document.getElementById('app'), '/', {
  '/': defaultPage,
  '/auth': auth,
  '/stationFinder': stationFinder,
  '/journeyPlan': journeyPlan,
  '/journeyPlan/add': journeyPlanAdd,
  '/cardList': cardList,
  '/departments': departments,
  '/drivers': drivers,
  '/dashboard': dashboard,
  '/transactions': transactions,
  '/cardToCard': cardToCard,
  '/cardToCard/single': cardToCardSingle,
  '/cardToCard/bulk': cardToCardBulk,
  '/reports': reports,
  '/userManagement': usermanagement,
  '/profiles': profiles,
  '/notifications': notifications,
  '/notifications/triggers': triggers,
  '/support': support,
  '/tutorials': tutorials,
  '/trends': trends,
  '/funds':topUps
});


// console disabling like facebook does, so that all console.logs just fail silently
